
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ramadan-coding-camp",
      function () {
        return require("private-next-pages/ramadan-coding-camp.tsx");
      }
    ]);
  